<app-confirm-card
  title="Delete Blog?"
  message="If you delete this blog, you cannot recover it. This action cannot be undone."
  confirmLabel="Yes, Delete"
  loadingLabel="Deleting..."
  [loading]="isLoading"
  (confirm)="deleteBlog()"
  (cancel)="cancelBlog()"
></app-confirm-card>
